import { type TopicKey } from './onboard.types';
import { useOnboardStore } from './useOnboardStore';

type GenericNode = { id?: string } | null;

export function useOnboardTarget(topic: TopicKey, stepId: string) {
    const flow = useOnboardStore((state) => state.flow);
    const setTarget = useOnboardStore((state) => state.setTarget);
    const getStep = useOnboardStore((state) => state.getStep);

    const activeStep = flow ? getStep(flow.topicKey, flow.stepIndex) : undefined;

    const matchingTopic = topic === flow?.topicKey;
    const matchingStep = stepId === activeStep?.id;

    return matchingTopic && matchingStep ? (node?: GenericNode) => setTarget(node?.id) : undefined;
}
